import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

export interface UIState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => set({ theme }),
    }),
    { name: 'gelirgider-admin-ui' },
  ),
);

function effectiveTheme(theme: Theme): 'light' | 'dark' {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  const next = effectiveTheme(theme);
  if (next === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

export function initTheme(): () => void {
  applyTheme(useUIStore.getState().theme);
  const unsubscribe = useUIStore.subscribe((state) => applyTheme(state.theme));
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  const onSystemChange = (): void => {
    if (useUIStore.getState().theme === 'system') applyTheme('system');
  };
  mediaQuery.addEventListener('change', onSystemChange);
  return () => {
    unsubscribe();
    mediaQuery.removeEventListener('change', onSystemChange);
  };
}
